'use strict'

export let english={
  period: {
    hideCalendar: "Hide calendar",
    from: "From",
    to: "to",
    pleaseSelect: "Please select the",
    firstDay:"first day",
    lastDay: "last day",
    fromUndefinedTo: "From <not defined> to",
    months: undefined,
    weekdaysShort: undefined
  },
  status: {
    green: "Forecast is within tolerances",
    yellow: "Issues or risks have surfaced. If not properly dealt with, the stage or project's forecast can end up breaking the tolerances",
    red: "Forecasting broken tolerances. Exeption plan needed."
  },
  form: {
    cancel: "Close / Cancel",
    add: "Add",
    update: "Update",
    delete: "Delete",
    confirmDeleteMessage: "Do you want to delete this output?",
    cancelDelete: "Cancel",
    changesAreSaved: "Changes are saved!"
  },
  menu: {
    approve: "Approve",
    retractRequest: "Retract request",
    request: "Request",
    recommend: "Recommend",
    retract: "Retract",
    progress: "Progress",
    status: "Status",
    startProject: "Start project",
    pauseProject: "Pause project",
    stopProject: "Stop project",
    startProgramme: "Start programme",
    pauseProgramme: "Pause programme",
    stopProgramme: "Stop programme",
    actions: "Actions",
    editProperties: "Edit properties",
    openLog: "Open log",
    projectSettings: "Project Settings",
    cloneProject: "Clone project",
    prepareProjectClosure: "Prepare Project Closure"
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/english.js